(function () {
  'use strict';

  var selector = '.olle-more-info';
  var readyAttribute = 'data-olle-more-info-ready';
  var instanceCount = 0;

  function updateExpandedHeight(content) {
    content.parentNode.style.setProperty('--olle-more-info-expanded-height', content.scrollHeight + 'px');
  }

  function initialize(target) {
    if (!target || target.hasAttribute(readyAttribute)) return;

    target.setAttribute(readyAttribute, 'true');
    instanceCount += 1;

    var parent = target.parentNode;
    var shell = document.createElement('div');
    var content = document.createElement('div');
    var button = document.createElement('button');
    var label = document.createElement('span');
    var icon = document.createElement('span');
    var contentId = 'olle-more-info-content-' + instanceCount;

    shell.className = 'olle-more-info-shell';
    Array.prototype.forEach.call(target.classList, function (className) {
      if (/^pf-(?:xs-|sm-|md-|lg-)?hide$/.test(className)) {
        shell.classList.add(className);
      }
    });

    content.className = 'olle-more-info-shell__content';
    content.id = contentId;

    button.className = 'olle-more-info-shell__toggle';
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', contentId);

    label.className = 'olle-more-info-shell__label';
    label.textContent = 'More Info';

    icon.className = 'olle-more-info-shell__icon';
    icon.setAttribute('aria-hidden', 'true');

    parent.insertBefore(shell, target);
    content.appendChild(target);
    button.appendChild(label);
    button.appendChild(icon);
    shell.appendChild(content);
    shell.appendChild(button);

    updateExpandedHeight(content);

    Array.prototype.forEach.call(content.querySelectorAll('img'), function (image) {
      if (!image.complete) {
        image.addEventListener('load', function () {
          updateExpandedHeight(content);
        });
      }
    });

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function () {
        updateExpandedHeight(content);
      });
      resizeObserver.observe(target);
    }
  }

  function handleToggle(event) {
    var button = event.target.closest('.olle-more-info-shell__toggle');
    if (!button) return;

    var shell = button.closest('.olle-more-info-shell');
    var content = shell.querySelector('.olle-more-info-shell__content');
    var label = button.querySelector('.olle-more-info-shell__label');
    var expanded = !shell.classList.contains('is-expanded');

    updateExpandedHeight(content);
    shell.classList.toggle('is-expanded', expanded);

    button.setAttribute('aria-expanded', String(expanded));
    label.textContent = expanded ? 'Less Info' : 'More Info';

    if (!expanded && shell.getBoundingClientRect().top < 0) {
      shell.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    }
  }

  function initializeWithin(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;

    if (root.matches && root.matches(selector)) initialize(root);

    Array.prototype.forEach.call(root.querySelectorAll(selector), initialize);
  }

  function start() {
    initializeWithin(document);
    document.addEventListener('click', handleToggle);

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, initializeWithin);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
